module.exports = __webpack_public_path__ + "img/starperformers-head-long@2x.ec40ff2c.png";